import React from 'react';
import Card from '../Card';
import Skeleton from '../Skeleton/Skeleton';
import { onRequestPhoneCall } from '../../helpers/validationHelper';

const ContactCard = ({ contact, loading }) => {
  if (loading) {
    return (
      <Card
        title="Contact Information"
        body={(
          <>
            <div><Skeleton variant="text" width="60%" /></div>
            <div><Skeleton variant="text" width="40%" /></div>
            <div><Skeleton variant="text" width="70%" /></div>
            <div><Skeleton variant="text" width="80%" /></div>
          </>
        )}
      />
    );
  }

  return (
    <Card
      title="Contact Information"
      body={(
        <>
          <div>{contact.description}</div>
          <div>{onRequestPhoneCall(contact.phone)}</div>
          <div>{contact.office}</div>
          <div>{contact.email}</div>
        </>
      )}
    />
  );
};

export default ContactCard;
